import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useMemo } from "react";

import * as S from "./styled";

import { ImportStatus } from "./types";

interface Props {
  status: ImportStatus | undefined;
}

export const ImportStatusStep = ({ status }: Props) => {
  const content = useMemo(() => {
    if (!status) {
      return (
        <S.SpinnerContainer>
          <CircularProgress />
        </S.SpinnerContainer>
      );
    }

    if (status.status === "success") {
      return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <S.ImportSuccess />
        </Box>
      );
    }

    if (status.status === "error") {
      return <S.ImportError>{status.message}</S.ImportError>;
    }
  }, [status]);

  return <S.DialogContentContainer>{content}</S.DialogContentContainer>;
};
